import React from 'react';
import { styled } from '@mui/material/styles';
import { TextFieldProps } from '@mui/material/TextField';
import { TextField } from '@mui/material';
import { warningColor } from './project.type';

interface CustomizedTextFieldProps extends Omit<TextFieldProps, 'label'> {
  errorFieldNames?: string[]; // Optional for use case 1
  label?: string; // Optional for use case 1
  hasError?: boolean; // Optional for use case 2
}

const CustomizedTextField = styled((props: CustomizedTextFieldProps) => <TextField {...props} />)(({
  theme,
  errorFieldNames,
  label,
  hasError,
}) => {
  // Determine if the field should be highlighted with a warning color
  const shouldHighlight = hasError || (errorFieldNames && label && errorFieldNames.includes(label));

  return {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: shouldHighlight ? warningColor : undefined,
      },
      '&:hover fieldset': {
        borderColor: shouldHighlight ? warningColor : undefined,
      },
      '&.Mui-focused fieldset': {
        borderColor: shouldHighlight ? warningColor : theme.palette.primary.main,
      },
    },
    '& .MuiInputLabel-root': {
      display: label ? 'inherit' : 'none',
    },
  };
});

export default CustomizedTextField;
